import { useQuery } from '@tanstack/react-query'
import { getDemandById } from 'services/demands/demandsServices'

export default function useDemandDetails(id) {
	const { data, isLoading, isError, error } = useQuery({
		queryKey: ['demand', id],
		queryFn: () => getDemandById(id),
		enabled: !!id,
		staleTime: 1000 * 30,
		refetchOnWindowFocus: true,
		retry: false,
	})

	return { data, isLoading, isError, error }
}
